import { fromOverheadsDTO, toOverheadsDTO } from "../dto/overheadsMapper";

/**
 * Overheads Service
 * Patches company overheads and normalizes the response.
 */
export function createOverheadsService({ apiClient, apiUrl, interpolateURL, logError, debug }) {
  const useDebug = !!debug?.useDebugMode;
  const fetchWithAwait = (params) => apiClient({ ...params, mode: "resolution" });

  /**
   * Re-attach client-side flags (e.g., skipField) after server patch.
   */
  function reattachSkipFlags(serverOverheads, clientOverheads) {
    const byId = new Map(clientOverheads.map((o) => [o.id, o]));
    return serverOverheads.map((item) => {
      const src = byId.get(item.id);
      return src ? { ...item, skipField: !!src.skipField } : { ...item };
    });
  }

  /**
   * Patch overheads for a given company input id.
   */
  async function patchOverheads({ companyInputId, overheads, translate, hash }) {
    const endpoint = "company-overhead";
    let normalized;
    try {
      if (useDebug) console.log("====== PATCH Company Overheads =====");
      await fetchWithAwait({
        method: "PATCH",
        url: interpolateURL({ apiUrl, endpoint, id: null, omitLanguage: false }),
        body: toOverheadsDTO(companyInputId, overheads),
        hash,
        ignoreLoader: true,
        onSuccess: ({ data }) => {
          if (useDebug) console.log(`${endpoint}:`, data);
          const response = fromOverheadsDTO(data, translate);
          normalized = reattachSkipFlags(response, overheads);
        },
        onError: (err) => {
          throw err;
        },
        ignoreError: false,
      });
      return { ok: true, data: normalized, error: null };
    } catch (error) {
      logError(endpoint, error);
      return { ok: false, data: undefined, error };
    }
  }

  return { patchOverheads };
}
